import { TObject } from 'utils/types';

import {
  type IMetadataTemplate,
  METADATA_TEMPLATE_GROUP_TYPE,
  type TMetadataTemplatesMap,
} from './types';

export type TMetadataTemplateData = TObject & {
  merchant: TObject;
  merchantTerminal: TObject;
};

export const normalizeMetadataTemplate = (
  data: TMetadataTemplateData,
): IMetadataTemplate => ({
  groupType: (data?.groupType as METADATA_TEMPLATE_GROUP_TYPE) || null,
  id: (data?.id as number) || 0,
  key: (data?.key as string) || '',
  merchant: {
    id: (data?.merchant?.id as number) || 0,
    name: (data?.merchant?.name as string) || '',
  },
  merchantTerminal: {
    id: (data?.merchantTerminal?.id as number) || 0,
    name: (data?.merchantTerminal?.name as string) || '',
  },
  values: Array.isArray(data.values) ? data.values : [],
});

export const normalizeMetadataTemplatesMap = (raw: unknown): TMetadataTemplatesMap => {
  if (!raw || typeof raw !== 'object') {
    return {};
  }
  const result: TMetadataTemplatesMap = {};
  Object.entries(raw as Record<string, unknown>).forEach(([key, values]) => {
    if (!Array.isArray(values)) {
      return;
    }
    result[key] = values.filter((v): v is string => typeof v === 'string');
  });
  return result;
};
